/**
 * Copyright (c) Matthieu POIGNANT
 * matthieu@highlight.pro
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 */
import Interface from '../../interface';

const EmptyAvatar = Interface.styled('span')`
  z-index: 3;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  margin-top: auto;
  margin-right: 8px;
`;

export default EmptyAvatar;
